module.exports = __webpack_public_path__ + "static/media/66790003-BhF0wSgs.13d31308.JPG";